import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AuthService from "../../services/authService";
import { useNavigate } from "react-router-dom";
import logo from '../../assets/logo.png';

const pages = ['Home', 'Register', 'Downloads', 'Ranks', 'Market', 'Updates', 'Schedule', 'Store'];
const pagesPath = ['/', '/user/register', '/downloads', '/ranks', '/marketplace', '/updates', '/schedules', '/'];
const settingsLoggedIn = ['Change Password', 'Logout'];
const loggedInPages = ['/user/change-password', '/user/logout'];
const settingsLoggedOut = ['Login', 'Forgot password'];
const loggedOutPages = ['/user/login', '/user/forgot-password'];

function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const history = useNavigate();

    const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
    const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
    const handleCloseNavMenu = (page) => {
        setAnchorElNav(null);
        if (page) doNav(page);
    };
    const handleCloseUserMenu = (page) => {
        setAnchorElUser(null);
        if (page) doNav(page);
    };

    const doNav = (page) => {
        const index = pages.indexOf(page);
        if (index !== -1) return history(pagesPath[index]);
        const index2 = settingsLoggedIn.indexOf(page);
        if (index2 !== -1) return history(loggedInPages[index2]);
        const index3 = settingsLoggedOut.indexOf(page);
        if (index3 !== -1) return history(loggedOutPages[index3]);
    };

    return (
        <AppBar position="static" sx={{ backgroundColor: '#111', boxShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
            <Container maxWidth="xl" sx={{ py: 1 }}>
                <Toolbar disableGutters>
                    {/* Logo + Mobile Menu */}
                    <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 2 }}>
                        <IconButton
                            size="large"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElNav}
                            open={Boolean(anchorElNav)}
                            onClose={() => handleCloseNavMenu()}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page} onClick={() => handleCloseNavMenu(page)}>
                                    <Typography textAlign="center" sx={{ fontFamily: 'Poppins, sans-serif' }}>{page}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>

                    {/* Desktop Logo */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 2 }}>
                        <img src={logo} alt="logo" style={{ height: 60, borderRadius: 4 }} />
                    </Box>

                    {/* Nav Buttons */}
                    <Box sx={{ flexGrow: 1, justifyContent: 'center', display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page) => (
                            <Button
                                key={page}
                                onClick={() => handleCloseNavMenu(page)}
                                sx={{
                                    my: 1,
                                    mx: 1.5,
                                    color: 'white',
                                    fontWeight: 500,
                                    fontSize: '0.95rem',
                                    fontFamily: 'Poppins, sans-serif',
                                    textTransform: 'uppercase',
                                    transition: 'all 0.3s ease-in-out',
                                    '&:hover': {
                                        color: '#FFD700',
                                        backgroundColor: 'rgba(255,255,255,0.05)',
                                        borderRadius: '6px',
                                    },
                                }}
                            >
                                {page}
                            </Button>
                        ))}
                    </Box>

                    {/* User Avatar */}
                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="User options">
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar sx={{ bgcolor: '#444' }} />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{ mt: '45px' }}
                            anchorEl={anchorElUser}
                            open={Boolean(anchorElUser)}
                            onClose={() => handleCloseUserMenu()}
                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        >
                            {(AuthService.isUserLoggedIn() ? settingsLoggedIn : settingsLoggedOut).map((setting) => (
                                <MenuItem key={setting} onClick={() => handleCloseUserMenu(setting)}>
                                    <Typography textAlign="center" sx={{ fontFamily: 'Poppins, sans-serif' }}>{setting}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default ResponsiveAppBar;
